import * as THREE from "three";
import * as dat from "lil-gui";

import SceneTransition from "./SceneTransition.js";
import Camera from "./Camera.js";
import Time from "../webgl/utils/Time.js";
import SizesTransition from "./SizesTransition.js";
import Renderer from "./Renderer.js";
import Resources from "./Resources.js";

import basicVertexShader from './shaders/basic/basic.vert'
import basicFragmentShader from './shaders/basic/basic.frag'

import sources from './sources.js';

let instanceTransition = null;

export default class Transition {
  constructor(canvas, video) {
    // Singleton
    if (instanceTransition) {
      return instanceTransition;
    }
    instanceTransition = this;
    window.transition = this;

    // Variables
    this.canvas = canvas;
    this.sizes = new SizesTransition();
    this.time = new Time();

    this.scene = new THREE.Scene();
    this.camera = new Camera();
    this.renderer = new Renderer();

    this.resources = new Resources(sources);

    this.texture = null;

    this.videoMaterial = new THREE.ShaderMaterial({
        uniforms:
        {
            tTexture: { value: null },
            tColorTexture: { value: null },
        },
        vertexShader: basicVertexShader,
        fragmentShader: basicFragmentShader,
        transparent: true,
      })

    this.world = new SceneTransition();

    this.video = video;

    this.resources.on('ready', () => {
        this.init();
      });



    // Resize event
    this.sizes.on("resize", () => {
      this.resize();
    });

    // Time tick event
    this.time.on("tick", () => {
      this.update();
    });
  }

  resize() {
    this.camera.resize();
    this.renderer.resize();
    this.world.resize();
  }

  update() {
    this.camera.update();
    this.renderer.update();
  }

  initVideo() {
    this.video.play();
    this.video.playbackRate = 2.0;

    this.texture = new THREE.VideoTexture(this.video);
    this.texture.needsUpdate = true;

    this.videoMaterial.uniforms.tTexture.value = this.texture;
    this.videoMaterial.uniforms.tColorTexture.value = this.resources.items.bg;
    
    this.videoMaterial.needsUpdate = true;

  }

  init() {
    this.initVideo(this.video);
  }

  initGUI() {
    this.gui = new dat.GUI();

    this.gui.close();
  }

  destroy() {
    this.sizes.off("resize");
    this.time.off("tick");

    this.renderer.destroy();

    this.scene.traverse((child) => {
      // Test if it's a mesh
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();

        // Loop through the material properties
        for (const key in child.material) {
          const value = child.material[key];

          // Test if there is a dispose function
          if (value && typeof value.dispose === "function") {
            value.dispose();
          }
        }
      }
    });

    this.video.pause();

    instanceTransition = null;

  }
}
